import './page.scss';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ReCAPTCHA from 'react-google-recaptcha';

const FeedbackForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { id } = useParams();
  useEffect(() => {
  const el = document.querySelector('.navbar');
  if (el) el.scrollIntoView({ behavior: 'auto' });
}, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert('Please complete the CAPTCHA');
      return;
    }

    if (!name.trim() || !email.trim() || !message.trim()) {
      alert('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`https://ng-api-p21r.onrender.com/api/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message, captchaValue }),
      });

      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        window.location.href = '/';
      } else {
        alert(data.message || 'Failed to submit feedback.');
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Something went wrong.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCaptchaChange = (value) => setCaptchaValue(value);

  const handleCaptchaExpire = () => {
    setCaptchaValue(null);
    alert('CAPTCHA expired. Please complete it again.');
  };

  return (
    <><Helmet>
  <title>Contact support – Naijads</title>
  <meta name="description" content="Need help? Contact Naijads support team through our feedback form." />
  <link rel="canonical" href="https://www.naijads.ng/feedback" />
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact Naijads",
      "url": "https://www.naijads.ng/feedback",
      "description": "Send your message or question to the Bobseller support team using our feedback form.",
      "about": {
        "@type": "Organization",
        "name": "Naijads",
        "url": "https://www.naijads.ng",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.naijads.ng/Tayo.svg"
        }
      }
    })}
  </script>
</Helmet>
    <div className="feedback">
      <div className="feedbackFormContainer">
        <form id="feedbackForm" onSubmit={handleSubmit}>
          <h1>Do You have any questions? We&apos;ll help!</h1>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Your name"
          />
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Email"
          />
          <textarea
            className="textarea"
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            placeholder="Type a message..."
          />
          <ReCAPTCHA
            sitekey="6Lf7d4ErAAAAABZ7BVxES8W6ravfgVYdMnXwhbjA"
            onChange={handleCaptchaChange}
            onExpired={handleCaptchaExpire}
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  </>);
};

export default FeedbackForm;
